import React, { Component, Fragment } from 'react';
import { toastr } from "react-redux-toastr"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import ReactDatatable from '@ashvin27/react-datatable';
import {
    getData, enviaPriceRegistros, getDataTdsRevendas
} from "./priceActions"
import { logout } from "./../../../auth/authActions"
import Spinner from 'react-bootstrap/Spinner';
import { Modal } from "react-bootstrap";

import minhaImagemTodos from "../../../../src/figuras/exportar-todos.png";
import minhaImagemSelc from "../../../../src/figuras/exportar-selecinados.png";

class Price extends Component {
    constructor(props) {
        super(props)

        this.state = {
            arrayMarcados: []

            , arrayEnviarTodos_CodCatite: []
            , arrayEnviarTodos_conditionId: []

            , arrayEnviar_CodCatite: []
            , arrayEnviar_conditionId: []

            , SelPuxada: 0
            , booLerRecords: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? true : false)
            , MsgModal2: ""

        }

        if (this.props.codPuxada !== undefined && this.props.codPuxada !== null) {
            this.props.getData(this.props.codPuxada);
        }
        else {
            this.props.getDataTdsRevendas();

        }

        this.columns = [

            {
                key: "action1",
                text: "",
                className: "action1",
                width: 30,
                align: "center",
                sortable: false,
                cell: (record, index) => {
                    return (
                        <Fragment>
                            <input
                                name="isGoing"
                                type="checkbox"
                                onClick={this.selecionaCheck.bind(this, record, index)}
                            >
                            </input >
                        </Fragment>
                    );
                }
            },

            {
                key: "reseller",
                text: "Reseller",
                className: "reseller",
                sortable: true
            },
            {
                key: "productId",
                text: "ProductId",
                className: "productId",
                sortable: true
            },
            {
                key: "groupId",
                text: "GroupId",
                className: "groupId",
                sortable: true
            },
            {
                key: "conditionId",
                text: "ConditionId",
                className: "conditionId",
                sortable: true
            },
            {
                key: "conditionType",
                text: "ConditionType",
                className: "conditionType",
                sortable: true

            },
            {
                key: "conditionValue",
                text: "ConditionValue",
                className: "conditionValue",
                sortable: true

            },
            {
                key: "DiscountValue",
                text: "DiscountValue",
                className: "DiscountValue",
                sortable: true
            },
            {
                key: "conditionCurrency",
                text: "ConditionCurrency",
                className: "conditionCurrency",
                sortable: true
            },
            {
                key: "startDate",
                text: "StartDate",
                className: "startDate",
                sortable: true
            },
            {
                key: "endDate",
                text: "EndDate",
                className: "endDate",
                sortable: true
            },
            {
                key: "sendToHybrisStatus",
                text: "SendToHybSts",
                className: "sendToHybrisStatus",
                sortable: true
            },
            {
                key: "sendToHybrisAt",
                text: "SendToHybrisAt",
                className: "sendToHybrisAt",
                sortable: true
            },

        ];
        this.config = {
            key_column: 'productId,groupId,conditionId',
            page_size: 10,
            length_menu: [10, 20, 50],
            button: {
                excel: true,
                print: true,
                extra: true,
            },
            filename: "Price",

            language: {
                length_menu: "Mostrar _MENU_ registros por página",
                filter: "Buscar em registros ...",
                info: "Mostrando _START_ a _END_ de _TOTAL_ entradas",
                pagination: {
                    first: "Primeira",
                    previous: "Anterior",
                    next: "Próxima",
                    last: "Última"
                },
                loading_text: "Aguarde buscando informações..."
            }

        }

        this.extraButtons = [
            {
                className: "btn btn-success  ",
                title: "Exporta Selecionados",
                children: [
                    <img src={minhaImagemSelc} alt="" ></img>
                ],
                onClick: () => { this.ExportaSelecao(); },
            },
            {
                className: "btn btn-success ",
                title: "Exporta Todos",
                children: [
                    <img src={minhaImagemTodos} alt="" ></img>
                ],
                onClick: () => { this.ExportaTodos(); },
            },
        ]

        this.ExportaSelecao = this.ExportaSelecao.bind(this);
        this.ExportaTodos = this.ExportaTodos.bind(this);
        this.PopulararrayEnviarTodos = this.PopulararrayEnviarTodos.bind(this);
        this.setbscInf = this.setbscInf.bind(this);
        this.setPuxada = this.setPuxada.bind(this);

    }

    setPuxada(e) {
        this.setState({
            SelPuxada: (e.target.value === "" ? 0 : e.target.value)
            , booLerRecords: false
        });
    }

    openModal = (qualfiltro) => {
        this.setState({ isModalOpen: qualfiltro });
    }

    closeModal = () => this.setState({ isModalOpen: 0, LimpaRegReposta: true })


    setbscInf() {
        if (this.state.SelPuxada === null || Number(this.state.SelPuxada) === 0 || this.state.SelPuxada === undefined) {
            toastr.warning("Atenção Selecione uma Revenda")
        }
        else {
            this.setState({
                MsgModal2: "Processando solicitação..."
            });
            this.openModal(2)
            this.props.getData(this.state.SelPuxada);
            setTimeout(() => {
                this.setState({
                    booLerRecords: true
                    , isModalOpen: 0
                });
            }, 500);
        }
    }

    PopulararrayEnviarTodos() {

        this.setState({
            arrayEnviarTodos_CodCatite: []
            , arrayEnviarTodos_conditionId: []
        });
        if (this.props.redListaPrice !== undefined && this.props.redListaPrice !== null) {
            for (let i = 0, l = this.props.redListaPrice.length; i < l; i++) {
                this.state.arrayEnviarTodos_CodCatite.push(this.props.redListaPrice[i].productId);
                this.state.arrayEnviarTodos_conditionId.push(this.props.redListaPrice[i].conditionId);
            }
        }
    }

    selecionaCheck = (registro, record, index) => {

        const array1 = [];
        const array2_CodCatite = [];
        const array2_conditionId = [];

        let Existe = [{}];

        Existe =
            (
                this.state.arrayMarcados
                    .filter((a) => a.productId === registro.productId &&
                        a.conditionId === registro.conditionId
                    )
            )


        if (Existe.length === 0) {
            this.state.arrayMarcados.push(registro)

            this.state.arrayEnviar_CodCatite.push(registro.productId);
            this.state.arrayEnviar_conditionId.push(registro.conditionId);

        }
        else {
            //Carrega Array1
            for (let i = 0, l = this.state.arrayMarcados.length; i < l; i++) {
                if (this.state.arrayMarcados[i].productId === registro.productId &&
                    this.state.arrayMarcados[i].conditionId === registro.conditionId) { }
                else {
                    array1.push(this.state.arrayMarcados[i]);
                    array2_CodCatite.push(this.state.arrayMarcados[i].productId);
                    array2_conditionId.push(this.state.arrayMarcados[i].conditionId);
                }
            }

            this.setState({
                arrayEnviar_CodCatite: array2_CodCatite
                , arrayEnviar_conditionId: array2_conditionId
                , arrayMarcados: array1
            });

        }

    }

    ExportaSelecao() {
        if (this.state.arrayMarcados.length === 0) {
            toastr.warning("Não há seleção realizada !!!!")
        }
        else {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(2)
            this.props.enviaPriceRegistros(
                this.state.arrayEnviar_CodCatite
                , this.state.arrayEnviar_conditionId
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario)

            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviar_CodCatite: []
                    , arrayEnviar_conditionId: []
                    , isModalOpen: 0
                });
            }, 4000);
        }

    }

    ExportaTodos() {

        this.PopulararrayEnviarTodos();
        let podeenviar = true;

        if (this.state.arrayEnviarTodos_CodCatite.length === 0) {
            toastr.warning("Não há produtos a enviar !!!!")
            podeenviar = false
        }
        if (this.props.codPuxada === undefined || this.props.codPuxada === null) {
            if (this.state.SelPuxada === undefined
                || this.state.SelPuxada === null
                || this.state.SelPuxada === 0) {
                toastr.warning("Revenda não selecionada !!!!")
                podeenviar = false;
            }
        }

        if (podeenviar === true) {
            this.setState({
                MsgModal2: "Enviando a solicitação... Será realizado em fila processamentos"
            });
            this.openModal(2)
            this.props.enviaPriceRegistros(
                this.state.arrayEnviarTodos_CodCatite
                , this.state.arrayEnviarTodos_conditionId
                , (this.props.codPuxada === undefined || this.props.codPuxada === null
                    ? this.state.SelPuxada : this.props.codPuxada)
                , this.props.nomeUsuario)

            setTimeout(() => {
                this.setState({
                    arrayMarcados: []
                    , arrayEnviarTodos_CodCatite: []
                    , arrayEnviarTodos_conditionId: []
                    , isModalOpen: 0
                });
            }, 4000);
        }
    }

    // componentDidMount () {
    //     setTimeout(() => {
    //         this.setState({
    //             loading: false,
    //             records: this.props.redListaPrice || []
    //         })
    //     }, 3000);
    // }

    render() {
        const Listapuxadas = this.props.redListaTdsRevendas || [];

        return (

            <div className="container" >

                <div className="row">
                    <div className="Col">
                        <span className="cadastro-Externos">Inicial / &nbsp;
                            <span className="text-style-1">Price</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div className="row" style={{
                    display: (this.props.codPuxada === undefined || this.props.codPuxada === null ? "flex" : "none")
                    , fontSize: "18px", color: "#77b935", fontFamily: "Barlow"
                }}>
                    <div className="col">
                        <select id="Revenda"
                            value={this.state.SelPuxada}
                            onChange={this.setPuxada}
                        >
                            <option value="">-- Selecione Revenda --</option>
                            {Listapuxadas
                                .map((ar, i) => (
                                    <option key={i} value={ar.cod_puxada}>
                                        {ar.cod_puxada + " - " + ar.dsc_razaosocial}
                                    </option>
                                ))}
                        </select>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <button type="button"
                            style={{ fontSize: "18px", color: "#77b935" }}
                            data-toggle="tooltip"
                            title="Adiciona a Lista"
                            onClick={this.setbscInf}

                        >
                            <i className="fa fa-refresh " aria-hidden="true"></i>
                        </button>
                    </div>
                    <br />
                    <br />
                </div>
                <div className="row"
                    style={{
                        display: (this.props.codPuxada !== undefined && this.props.codPuxada !== null ? "flex" : "none")
                        , fontSize: "12px", color: "#77b935"
                    }}>
                    <div className="Col">
                        <span className="cadastro-Externos1">&nbsp;
                            <span>Código da Revenda: &nbsp; {(this.props.codPuxada === undefined || this.props.codPuxada === null ? 0 : this.props.codPuxada)}</span>
                        </span>
                    </div>
                    <br />
                    <br />
                </div>

                <div>
                    <ReactDatatable
                        config={this.config}
                        records={(this.state.booLerRecords === true ? this.props.redListaPrice || [] : [])}
                        columns={this.columns}
                        extraButtons={this.extraButtons}
                    // loading={this.state.loading}
                    />
                </div>

                {/*Modal leitura*/}
                <Modal size="sm" show={(this.state.isModalOpen === 2 ? true : false)}
                    className="modal fade" role="dialog"
                    onHide={this.closeModal}

                >
                    <Modal.Body >
                        <div className="row d-flex justify-content-center" >
                            <Spinner animation="border" role="status" variant="success">
                            </Spinner>
                        </div>
                        <div className="row" style={{ textAlign: "Center" }}>
                            <i className="fa-blink "> {this.state.MsgModal2}</i>
                            {/* <span> {this.state.MsgModal2} </span> */}

                        </div>
                    </Modal.Body>

                </Modal>

            </div>

        )
    }
}
const mapStateToProps = state => (
    {
        nomeUsuario: state.authRed.NomUsuario
        , codPuxada: state.authRed.CodPuxada
        , TipoLicenca: state.authRed.TipoUsuario
        , redListaTdsRevendas: state.priceReducer.ListaTdsRevendas
        , redListaPrice: state.priceReducer.listaprice
    }
)
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        getData
        , enviaPriceRegistros
        , logout
        , getDataTdsRevendas
    }
    , dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Price)